// Vendors
import React from 'react';
import { connectHitInsights, Hits } from 'react-instantsearch-dom';

// Components
import { ClearSearch } from '..';

// Helpers
import { truncateString } from '../../../../lib/utilities';

const ResourceHit = ({ hit, insights }) => {
  const {
    objectID,
    url,
    __queryID,
    image,
    label,
    title,
    description,
    price = undefined
  } = hit || {};

  return (
    <a
      key={objectID}
      href={`${url}?queryID=${__queryID}`}
      className="card-resource module-hover-root"
      onClick={() =>
        insights('clickedObjectIDsAfterSearch', {
          eventName: 'View Resource'
        })
      }
    >
      <div
        className="card-resource__image card-resource__image--contain"
        style={{
          backgroundImage: `url(${image})`
        }}
      >
        <img src="https://propane.com/wp-content/themes/wlion-2021/images/placeholders/480x360.gif" />
      </div>
      <div className="card-resource__main">
        <div className="card-resource__body">
          <div className="card-resource__body-default">
            <span className="card-resource__label">{label}</span>
            <h3 className="card-resource__title">{title}</h3>
          </div>
          <div className="card-resource__body-hover">
            <div
              dangerouslySetInnerHTML={{
                __html: truncateString(description, 125)
              }}
            />
          </div>
        </div>
        {price && <div className="card-resource__price">${price}</div>}
        <div className="card-resource__footer">
          <div className="card-resource__action btn btn--blue btn--has-arrow">
            <span className="btn__content">
              <span className="btn__text">See Details</span>
              <span className="btn__arrow arrow"></span>
            </span>
          </div>
        </div>
      </div>
    </a>
  );
};

const HitWithInsights = connectHitInsights(window.aa)(ResourceHit);

const ResourceHits = () => {
  return (
    <div className="resource-catalog-hits">
      <Hits hitComponent={HitWithInsights} />
    </div>
  );
};

export default ResourceHits;
